export const canonicalPaths = {
  home: '/',
  ceramicProtection: '/ceramic-protection',
  paintCorrection: '/paint-correction',
  detailing: '/detailing',
  detailingQuote: '/detailing/quote',
  gallery: '/gallery',
  about: '/about',
  contact: '/contact',
  book: '/book',
} as const

export const primaryNavItems = [
  { label: 'Home', href: canonicalPaths.home },
  { label: 'Ceramic Protection', href: canonicalPaths.ceramicProtection },
  { label: 'Paint Correction', href: canonicalPaths.paintCorrection },
  { label: 'Detailing', href: canonicalPaths.detailing },
  { label: 'Gallery', href: canonicalPaths.gallery },
  { label: 'About', href: canonicalPaths.about },
  { label: 'Contact', href: canonicalPaths.contact },
] as const

export const bookNowHref = canonicalPaths.book

const staticLegacyRedirects: Record<string, string> = {
  '/packages': canonicalPaths.ceramicProtection,
  '/ceramic-coating-geelong': canonicalPaths.ceramicProtection,
  '/car-detailing-geelong': canonicalPaths.detailing,
  '/interior-detailing': canonicalPaths.detailing,
  '/interior-detail': canonicalPaths.detailing,
  '/interior': canonicalPaths.detailing,
}

const bookingLegacyPaths = new Set([
  '/booking',
  '/booking/schedule',
  '/booking/summary',
  '/booking/payment-success',
  '/booking/payment-cancelled',
])

export function searchToQueryString(search: string | Record<string, unknown> | undefined): string {
  if (!search) return ''
  if (typeof search === 'string') return search.startsWith('?') ? search.slice(1) : search

  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(search)) {
    if (typeof value === 'string' && value.length > 0) params.set(key, value)
  }
  return params.toString()
}

function isStripeCheckoutReturnQuery(params: URLSearchParams) {
  const checkout = params.get('checkout')
  return checkout === 'return' || checkout === 'cancelled' || Boolean(params.get('session_id'))
}

function bookingCheckoutSearch(params: URLSearchParams) {
  const next = new URLSearchParams()
  const checkout = params.get('checkout')
  const sessionId = params.get('session_id')
  if (checkout === 'return' || checkout === 'cancelled') next.set('checkout', checkout)
  if (sessionId) next.set('session_id', sessionId)
  const query = next.toString()
  return query ? `${canonicalPaths.book}?${query}` : canonicalPaths.book
}

export function resolveLegacyRedirect(
  pathname: string,
  search?: string | Record<string, unknown>,
): string | null {
  const params = new URLSearchParams(searchToQueryString(search))

  if (isStripeCheckoutReturnQuery(params)) {
    if (pathname === canonicalPaths.book) return null
    if (bookingLegacyPaths.has(pathname)) return bookingCheckoutSearch(params)
  }

  if (params.get('path') === 'quote' && (pathname === '/booking' || pathname === '/book')) {
    return canonicalPaths.detailingQuote
  }

  if (pathname === canonicalPaths.contact && params.get('type') === 'detailing') {
    const interests = params.get('interests')
    return interests
      ? `${canonicalPaths.detailingQuote}?interests=${encodeURIComponent(interests)}`
      : canonicalPaths.detailingQuote
  }

  const staticTarget = staticLegacyRedirects[pathname]
  if (staticTarget) return staticTarget

  if (bookingLegacyPaths.has(pathname)) {
    const protection = params.get('protection') || params.get('package')
    if (protection) {
      const next = new URLSearchParams({ protection })
      return `${canonicalPaths.book}?${next.toString()}`
    }
    return canonicalPaths.book
  }

  return null
}
